import { render, staticRenderFns } from "./transactionStatusRenderer.vue?vue&type=template&id=01a05bf8"
import script from "./transactionStatusRenderer.vue?vue&type=script&lang=js"
export * from "./transactionStatusRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports